<template>
  <div class="container pkg-success">
    <div  v-if="companyPayment.paymentStatus==='Paid'">
      <div class="icon-wrp"><i class="ico-check_on"></i></div>
      <h1>Thank You!</h1>
      <p>Your payment is done successfully.</p>
      <strong class="transation-hist">Transaction ID: <span class="text-primary">{{ companyPayment.transaction_no }}</span></strong>
      <p>A payment receipt is sent to your registered email.</p>
      <router-link class="back-home" to="/">Go back to Home</router-link>
    </div>
    <div v-else>
      <div class="icon-wrp error"><i class="ico-check_on"></i></div>
      <h1>Payment Failed!</h1>
      <p>Your payment is Failed.</p>
      <strong class="transation-hist">Transaction ID: <span class="text-primary">{{ companyPayment.transaction_no }}</span></strong>
      <router-link class="back-home" to="/">Go back to Home</router-link>
    </div>

  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import router from "../../router/router";
import axios from "axios";
export default {
  data() {
    return {
      companyMemberships: {},
      companyPaymentMethod: {},
      paymentForm: {},
      companyPayment: {},
      company_id: this.$store.getters.getSelectedCompany.id,
      transactionOrderNo:this.$route.query.O,
    };
  },
  //success?RC=01&RD=PU&TS=F&O=tran_1671693148HeEKhT
  serverPrefetch() {},
  created() {
    this.getCompanyMembership();
    if(this.$route.query.O===undefined  || this.$route.query.O===''){
      this.$router.push({name: 'dashboard'});
    }else{
      this.paymentVerify()
    }
  },
  mounted() {},
  methods: {
    //---------- upgrade Fun--------------
    paymentVerify(){
      axios.post(this.$ComapnyPaymentVerify,
        {
          company_id:this.company_id,
          transactionOrderNo: this.transactionOrderNo,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status == 200) {
           //console.log(res.data.result,'res.data')
            this.companyPayment=res.data.result;

          }
        });
    },

    getCompanyMembership() {
      let params = {
        company_id: this.company_id,
      };
      this.$axios
        .get(this.$CompanyMembership, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.companyMemberships = response.data.result || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    currencyAmountFormat(value) {
      return this.currencyFormatter(value).toString().split(".")[0];
    }
  },
};
</script>


<style scoped>
.pkg-types .pkg{
  position: relative;
}
.free-pkg-tril{
  position: absolute;
  left: 0;
  bottom: 5px;
  width: 100%;
  text-align: center;
}
</style>
